export default __webpack_public_path__ + "static/media/lbp.59691430.webp";